/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_label_message = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const es_contact_label_message = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensaje`)
};

const de_contact_label_message = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht`)
};

const nl_contact_label_message = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht`)
};

const fr_contact_label_message = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const it_contact_label_message = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggio`)
};

const pt_br2_contact_label_message = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem`)
};

const pt_contact_label_message = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem`)
};

const ja_contact_label_message = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージ`)
};

const zh_contact_label_message = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`留言`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_label_message = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_label_message(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_label_message", locale)
	if (locale === "en") return en_contact_label_message(inputs)
	if (locale === "es") return es_contact_label_message(inputs)
	if (locale === "de") return de_contact_label_message(inputs)
	if (locale === "nl") return nl_contact_label_message(inputs)
	if (locale === "fr") return fr_contact_label_message(inputs)
	if (locale === "it") return it_contact_label_message(inputs)
	if (locale === "pt-BR") return pt_br2_contact_label_message(inputs)
	if (locale === "pt") return pt_contact_label_message(inputs)
	if (locale === "ja") return ja_contact_label_message(inputs)
	return zh_contact_label_message(inputs)
};